import React from 'react';

const TextOnlyAnswer = (props) =>
    props.question.question
        .split('\\n')
        .map((line) => <p className={props.disabled ? 'questionnaire-body disabled' : 'questionnaire-body'}>{line}</p>);
export default TextOnlyAnswer;
